/**
 * Created by robert.lavoie on 7/17/17.
 */

import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';
import { isPlatformBrowser } from '@angular/common';

import { Observable ,  of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import * as Raven from 'raven-js';

// Services
import { SiteService } from './site.service';


/**
 *
 * @class
 * LocationSearchService
 *
 * @description
 * This service is responsible for fetching location details from geo location api
 *
 */
@Injectable()
export class LocationSearchService {

  constructor(
    private siteService: SiteService,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  private static LOCAL_STORAGE_KEY: string = 'ip-location';
  private static LOCAL_STORAGE_TIME_KEY: string = 'ip-location-expires-at'; // in unix time
  private static LOCAL_STORAGE_CACHE_DURATION: number = 10; // in minutes

  /**
   * Get location details from a users IP, preferring a local cache if available
   *
   * @return { Observable }
   */
  public getLocationDataFromIP(): Observable<any> {

    // Return data as observable from cache if available
    if (isPlatformBrowser(this.platformId) && typeof localStorage !== 'undefined' && localStorage) {
      const data = JSON.parse(localStorage.getItem(LocationSearchService.LOCAL_STORAGE_KEY));
      const expiresAt = JSON.parse(localStorage.getItem(LocationSearchService.LOCAL_STORAGE_TIME_KEY));

      // Check if data is set and not expired, if so return it
      if (data !== null && Date.now() < Math.max(expiresAt, 0)) {
        return of(data);
      }
    }

    // Otherwise return the API request as normal
    return this.http.get(`${this.siteService.getApiUrl()}/geolocate`).pipe(
      tap(data => this.cacheIpData(data)),
      catchError(this.handleError)
    );

  }

  /**
   * Caches the location data by ip in local storage, if available
   * @see getLocationDataFromIP()
   */
  private cacheIpData(data) {
    if (isPlatformBrowser(this.platformId) && typeof localStorage !== 'undefined' && localStorage) {
      const expiresAt = Date.now() + (60000 * LocationSearchService.LOCAL_STORAGE_CACHE_DURATION); // minutes calculation
      // catch local storage error
      try {
        localStorage.setItem(LocationSearchService.LOCAL_STORAGE_KEY, JSON.stringify(data));
        localStorage.setItem(LocationSearchService.LOCAL_STORAGE_TIME_KEY, JSON.stringify(expiresAt));
      } catch (e) {
        if (this.isQuotaExceeded(e)) {
        }
      }
    }
  }


  /**
   * Handles the search errors
   *
   * @param { any }
   * @return { Observable }
   */
  private handleError(error: any): Observable<any> {
    Raven.captureException(error);
    return of(error);
  }

  /**
   * Handles the search errors
   *
   * @param { any } - error thrown when trying to write to storage
   * @return { boolean } - true if quota is exceeded
   */
  private isQuotaExceeded(e): boolean {
    let quotaExceeded = false;
    if (e) {
      if (e.code) {
        switch (e.code) {
          case 22:
            quotaExceeded = true;
            break;
          case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
              quotaExceeded = true;
            }
            break;
        }
      } else if (e.number === -2147024882) {
        // Internet Explorer 8
        quotaExceeded = true;
      }
    }
    return quotaExceeded;
  }


}
